// A hack here: determine if it is mobile rendering on start
// very un-angular, please refactor this in future.
const nativeAppSpecifiedInURL = window.location.href.indexOf('isNativeApp') >= 0;

export const constants = {
  http: {
    defaultApi: '/',
  },
  featured: [
    'COLES',
    'BIG_W',
    'MYER',
    'KMART',
    'DAN_MURPHYS',
    'CALTEX_STARCASH_DIGITAL',
    'JB_HI_FI',
    'WOOLWORTHS_WISH',
    'HVNSC0100001',
    'BUNNINGS_WAREHOUSE',
    'EBGSCVARI001',
    'DAVID_JONES',
  ],
  BUY_TYPES: {
    MYSELF: 'myself',
    FRIEND: 'friend',
    UNSELECTED: '',
  },
};
